import { useState } from "react";
import { Check, Link2, X } from "lucide-react";

const FONTS = [
  ["", "Police par défaut"],
  ["Arial", "Arial"],
  ["Verdana", "Verdana"],
  ["Georgia", "Georgia"],
  ["'Times New Roman'", "Times New Roman"],
  ["'Courier New'", "Courier New"],
];

const EMPTY = { label: "", url: "", color: "#0052FF", size: 14, font: "" };

export default function LinkInserter({ onInsert, testId = "link" }) {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(EMPTY);

  const insert = () => {
    if (!form.label.trim() || !form.url.trim()) return;
    let url = form.url.trim();
    if (!/^https?:\/\//i.test(url)) url = `https://${url}`;
    const opts = [`color=${form.color}`];
    if (Number(form.size)) opts.push(`size=${form.size}`);
    if (form.font) opts.push(`font=${form.font}`);
    onInsert(`[${form.label.trim()}](${url}|${opts.join("|")})`);
    setForm(EMPTY);
    setOpen(false);
  };

  if (!open) {
    return (
      <button
        type="button"
        data-testid={`insert-link-btn-${testId}`}
        onClick={() => setOpen(true)}
        className="mt-1.5 flex items-center gap-1.5 text-xs font-bold text-brand hover:underline"
      >
        <Link2 className="h-3.5 w-3.5" /> Insérer un lien cliquable
      </button>
    );
  }

  return (
    <div className="mt-2 space-y-2 rounded-xl border border-brand/30 bg-brand-soft/40 p-3" data-testid={`link-panel-${testId}`}>
      <div className="grid gap-2 sm:grid-cols-2">
        <input
          data-testid={`link-label-${testId}`}
          placeholder="Texte du lien (ex : Vérifier la compatibilité)"
          value={form.label}
          onChange={(e) => setForm((f) => ({ ...f, label: e.target.value }))}
          className="h-10 rounded-lg border border-line px-3 text-sm focus:border-brand focus:outline-none"
        />
        <input
          data-testid={`link-url-${testId}`}
          placeholder="https://exemple.com"
          value={form.url}
          onChange={(e) => setForm((f) => ({ ...f, url: e.target.value }))}
          className="h-10 rounded-lg border border-line px-3 text-sm focus:border-brand focus:outline-none"
        />
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <label className="flex items-center gap-1.5 text-[11px] font-bold text-slate-600">
          Couleur
          <input
            type="color"
            data-testid={`link-color-${testId}`}
            value={form.color}
            onChange={(e) => setForm((f) => ({ ...f, color: e.target.value }))}
            className="h-8 w-10 cursor-pointer rounded border border-line"
          />
        </label>
        <label className="flex items-center gap-1.5 text-[11px] font-bold text-slate-600">
          Taille
          <input
            type="number"
            min={10}
            max={32}
            data-testid={`link-size-${testId}`}
            value={form.size}
            onChange={(e) => setForm((f) => ({ ...f, size: e.target.value }))}
            className="h-8 w-16 rounded-lg border border-line px-2 text-xs"
          />
          px
        </label>
        <label className="flex items-center gap-1.5 text-[11px] font-bold text-slate-600">
          Police
          <select
            data-testid={`link-font-${testId}`}
            value={form.font}
            onChange={(e) => setForm((f) => ({ ...f, font: e.target.value }))}
            className="h-8 rounded-lg border border-line px-2 text-xs"
          >
            {FONTS.map(([value, label]) => (
              <option key={value} value={value}>{label}</option>
            ))}
          </select>
        </label>
      </div>
      {form.label && (
        <p className="rounded-lg bg-white px-3 py-2 text-xs text-slate-500">
          Aperçu :{" "}
          <span
            style={{ color: form.color, fontSize: `${form.size}px`, fontFamily: form.font || undefined }}
            className="font-bold underline underline-offset-2"
          >
            {form.label}
          </span>
        </p>
      )}
      <div className="flex gap-2">
        <button
          type="button"
          data-testid={`link-insert-${testId}`}
          onClick={insert}
          disabled={!form.label.trim() || !form.url.trim()}
          className="flex items-center gap-1.5 rounded-lg bg-brand px-4 py-2 text-xs font-bold text-white disabled:opacity-50"
        >
          <Check className="h-3.5 w-3.5" /> Insérer le lien
        </button>
        <button
          type="button"
          data-testid={`link-cancel-${testId}`}
          onClick={() => setOpen(false)}
          className="flex items-center gap-1.5 rounded-lg border border-line px-4 py-2 text-xs font-bold text-slate-600"
        >
          <X className="h-3.5 w-3.5" /> Annuler
        </button>
      </div>
    </div>
  );
}
